import { SaveSuccessItems } from "ui/Scripts/source/models/common/saveSuccessItems";
import { DocumentContentPreview } from "../document/documentContentPreview";
import { DocumentFilePreview } from "../document/documentFilePreview";
import { DocumentFolders } from "../document/documentFolders";
import { DocumentListItems } from "../document/documentListItems";
import { DocumentPage } from "../document/documentPage";
import { DocumentPageData } from "../document/documentPageData";
import { DocumentVersionPreview } from "../document/documentVersionPreview";
import { getApiCall, getFileApiCall, postApiCall, postFileApiCall } from "./tokenService";
import { IDocumentRemoveItem } from "../document/documentRemoveItem";
import { ApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";
import { DocumentFileEdit } from "../documentFile/documentFileEdit";
import { SaveSuccess } from "ui/Scripts/source/models/common/saveSuccess";
import { KeywordListItems } from "../keyword/keywordListItems";
import { KeywordEdit } from "../keyword/keywordEdit";
import { DocumentTemplateListItems } from "../documentTemplate/documentTemplateListItems";
import { DocumentTemplateEdit } from "../documentTemplate/documentTemplateEdit";
import { FileFilterListItems } from "../fileFilter/fileFilterListItems";
import { FileFilterEdit } from "../fileFilter/fileFilterEdit";
import { DocumentSettings } from "../documentSettings/documentSettings";
import { DocumentSettingsSave } from "../documentSettings/documentSettingsSave";
import { UserListItems } from "../user/userListItems";
import { DocumentFolderEdit } from "../documentFolder/documentFolderEdit";
import { DocumentDcoumentEdit } from "../documentDocument/documentDocumentEdit";
import { DocumentPublishResult } from "../documentDocument/documentPublishResult";
import { DocumentVersionListItems } from "../documentVersion/documentVersionListItems";
import { DocumentVersionEdit } from "../documentVersion/documentVersionEdit";
import { DocumentDocumentNew } from "../documentDocument/documentDocumentNew";
import { DocumentDocumentTemplateContent } from "../documentDocument/documentDocumentTemplateContent";
import { UploadFilesCheckResult } from "../document/uploadFilesCheckResult";

// #region DocumentPage
export const getDocumentPage = (): Promise<DocumentPage> => {
    return getApiCall("api/document", DocumentPage);
};

export const getDocumentPageData = (companyId: string): Promise<DocumentPageData> => {
    return getApiCall("api/document/pagedata?id=" + companyId, DocumentPageData);
};
// #endregion DocumentPage

// #region Folders
export const getDocumentFolders = (companyId: string): Promise<DocumentFolders> => {
    return getApiCall("api/document/folders?id=" + companyId, DocumentFolders);
};

export const getDocumentFoldersAndDocuments = (companyId: string): Promise<DocumentFolders> => {
    return getApiCall("api/document/foldersanddocuments?id=" + companyId, DocumentFolders);
};

export const removeFolder = (companyId: string, id: string): Promise<ApiSuccess> => {
    return postApiCall("api/document/folder/remove?id=" + id + "&companyId=" + companyId, ApiSuccess);
};

export const addFolder = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/document/folder/add", SaveSuccess, JSON.stringify(obj));
};

export const copyFolder = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/document/folder/copy", SaveSuccess, JSON.stringify(obj));
};

export const getDocumentFolderEdit = (companyId: string, folderId: string, isRoot: boolean): Promise<DocumentFolderEdit> => {
    return getApiCall("api/document/folder/edit?id=" + folderId + "&companyId=" + companyId + "&isRoot=" + isRoot.toString(), DocumentFolderEdit);
};

export const saveDocumentFolderEdit = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/document/folder/save", SaveSuccess, JSON.stringify(obj));
};

export const getDocumentSharedFolderEdit = (companyId: string, folderId: string, isRoot: boolean): Promise<DocumentFolderEdit> => {
    return getApiCall("api/document/folder/shared/edit?id=" + folderId + "&companyId=" + companyId + "&isRoot=" + isRoot.toString(), DocumentFolderEdit);
};

export const saveDocumentSharedFolderEdit = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/document/folder/shared/save", SaveSuccess, JSON.stringify(obj));
};
// #endregion Folders

// #region Documents
export const getDocumentListItems = (companyId: string, folderId: string): Promise<DocumentListItems> => {
    return getApiCall("api/document/documents?id=" + folderId + "&companyId=" + companyId, DocumentListItems);
};

export const searchDocumentListItems = (companyId: string, folderId: string, filter: string,
    startDate: number, endDate: number, dynamicTime: number,
    documentEndDateStartDate: number, documentEndDateEndDate: number, dynamicDocumentEndDate: number,
    keywordIds: string[], keywordOperator: number, documentApproval: number, documentContentSearch: number, maxResultsCount: number,
    sortColumn: string, sortOrderIsAsc: boolean): Promise<DocumentListItems> => {
    return postApiCall("api/document/search", DocumentListItems, JSON.stringify({
        companyId,
        folderId,
        sortColumn,
        sortOrder: sortOrderIsAsc ? "asc" : "desc",
        startDate: startDate || null,
        endDate: endDate || null,
        dynamicTime,
        documentEndDateStartDate: documentEndDateStartDate || null,
        documentEndDateEndDate: documentEndDateEndDate || null,
        dynamicDocumentEndDate,
        filter: filter || "",
        keywordIds,
        keywordOperator,
        documentApproval,
        documentContentSearch,
        maxResultsCount
    }));
};

export const getDocumentVersionPreview = (companyId: string, documentVersionId: string): Promise<DocumentVersionPreview> => {
    return getApiCall("api/document/versionpreview?id=" + documentVersionId + "&companyId=" + companyId, DocumentVersionPreview);
};

export const getDocumentContentPreview = (companyId: string, documentId: string): Promise<DocumentContentPreview> => {
    return getApiCall("api/document/contentpreview?id=" + documentId + "&companyId=" + companyId, DocumentContentPreview);
};

export const getFileContentPreview = (companyId: string, documentId: string, fileType: number): Promise<DocumentFilePreview> => {
    return getApiCall("api/document/filepreview?id=" + documentId + "&companyId=" + companyId + "&fileType=" + fileType.toString(10), DocumentFilePreview);
};

export const downloadFile = (companyId: string, id: string): Promise<string> => {
    return getFileApiCall("api/document/download?id=" + id + "&companyId=" + companyId);
};

export const downloadMultipleFiles = (companyId: string, ids: string[]): Promise<string> => {
    return postFileApiCall("api/document/downloadmultple", JSON.stringify({
        companyId,
        ids
    }));
};

export const uploadFilesCheck = (data: any): Promise<UploadFilesCheckResult> => {
    return postApiCall("api/document/checkupload", UploadFilesCheckResult, JSON.stringify(data));
};

export const uploadFiles = (data: any): Promise<SaveSuccessItems> => {
    return postApiCall("api/document/upload", SaveSuccessItems, JSON.stringify(data));
};

export const removeDocuments = (companyId: string, id: string, items: IDocumentRemoveItem[]): Promise<ApiSuccess> => {
    return postApiCall("api/document/remove", ApiSuccess, JSON.stringify({
        companyId,
        id,
        items
    }));
};

export const copyDocuments = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/document/copy", SaveSuccess, JSON.stringify(obj));
};
// #endregion Documents

// #region Document File
export const getDocumentFileEdit = (companyId: string, folderId: string, id: string): Promise<DocumentFileEdit> => {
    return getApiCall("api/document/file/edit?id=" + id + "&companyId=" + companyId + "&folderId=" + folderId, DocumentFileEdit);
};

export const saveDocumentFileEdit = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/document/file/save", SaveSuccess, JSON.stringify(obj));
};
// #endregion Document File

// #region Document
export const printDocuments = (companyId: string, ids: string[]): Promise<string> => {
    return postFileApiCall("api/document/print", JSON.stringify({
        companyId,
        ids
    }));
};

export const printDocument = (obj: any): Promise<string> => {
    return postFileApiCall("api/document/document/print", JSON.stringify(obj));
};

export const getDocumentDocumentNew = (companyId: string, folderId: string): Promise<DocumentDocumentNew> => {
    return getApiCall("api/document/document/new?id=" + companyId + "&folderId=" + folderId, DocumentDocumentNew);
};

export const getDocumentDocumentTemplateContent = (companyId: string, folderId: string, id: string, type: number): Promise<DocumentDocumentTemplateContent> => {
    return getApiCall("api/document/document/template/content?id=" + id + "&companyId=" + companyId + "&folderId=" + folderId + "&type=" + type, DocumentDocumentTemplateContent);
};

export const getDocumentDocumentEdit = (companyId: string, folderId: string, id: string): Promise<DocumentDcoumentEdit> => {
    return getApiCall("api/document/document/edit?id=" + id + "&companyId=" + companyId + "&folderId=" + folderId, DocumentDcoumentEdit);
};

export const saveDocumentDocumentEdit = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/document/document/save", SaveSuccess, JSON.stringify(obj));
};

export const approveDocument = (companyId: string, folderId: string, id: string): Promise<SaveSuccess> => {
    return postApiCall("api/document/document/approve?id=" + id + "&companyId=" + companyId + "&folderId=" + folderId, SaveSuccess);
};

export const publishDocument = (companyId: string, folderId: string, id: string): Promise<DocumentPublishResult> => {
    return postApiCall("api/document/document/publish?id=" + id + "&companyId=" + companyId + "&folderId=" + folderId, DocumentPublishResult);
};

export const unPublishDocument = (companyId: string, folderId: string, id: string, publishedId: string): Promise<DocumentPublishResult> => {
    return postApiCall("api/document/document/unpublish?id=" + id + "&companyId=" + companyId + "&folderId=" + folderId + "&publishedId=" + publishedId, DocumentPublishResult);
};
// #endregion Document

// #region Document Version
export const getDocumentVersionListItems = (companyId: string, folderId: string, id: string): Promise<DocumentVersionListItems> => {
    return getApiCall("api/document/versionhistory/list?id=" + id + "&companyId=" + companyId + "&folderId=" + folderId, DocumentVersionListItems);
};

export const getDocumentVersionEdit = (companyId: string, folderId: string, id: string): Promise<DocumentVersionEdit> => {
    return getApiCall("api/document/versionhistory/edit?id=" + id + "&companyId=" + companyId + "&folderId=" + folderId, DocumentVersionEdit);
};
// #endregion Document Version

// #region  Copy Documents and Folders
export const getTargetCompanyDocumentFolders = (companyId: string): Promise<DocumentFolders> => {
    return getApiCall("api/document/targetcompanyfolders?id=" + companyId, DocumentFolders);
};

export const getTargetCompanyUserListItems = (companyId: string, pageSize: number, page: number, filter: string, sortColumn: string, sortOrderIsAsc: boolean): Promise<UserListItems> => {
    return postApiCall("api/document/targetcompanyusers", UserListItems, JSON.stringify({
        companyId,
        pageSize,
        page,
        sortColumn,
        sortOrder: sortOrderIsAsc ? "asc" : "desc",
        filter: filter || "",
        activityState: 0
    }));
};
// #endregion Copy Documents and Folders

// #region Module Document Templates
export const getDocumentTemplateListItems = (companyId: string, pageSize: number, page: number, filter: string, sortColumn: string, sortOrderIsAsc: boolean): Promise<DocumentTemplateListItems> => {
    return postApiCall("api/document/module/documenttemplate/list", DocumentTemplateListItems, JSON.stringify({
        companyId,
        pageSize,
        page,
        sortColumn,
        sortOrder: sortOrderIsAsc ? "asc" : "desc",
        filter: filter || ""
    }));
};

export const getDocumentTemplateEdit = (companyId: string, id: string): Promise<DocumentTemplateEdit> => {
    return getApiCall("api/document/module/documenttemplate/edit?id=" + id + "&companyId=" + (companyId ?? ""), DocumentTemplateEdit);
};

export const saveDocumentTemplateEdit = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/document/module/documenttemplate/save", SaveSuccess, JSON.stringify(obj));
};

export const removeDocumentTemplates = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/document/module/documenttemplate/remove", ApiSuccess, JSON.stringify(obj));
};
// #endregion Module Document Templates

// #region Module File Filters
export const getFileFilterListItems = (companyId: string, pageSize: number, page: number, filter: string, sortColumn: string, sortOrderIsAsc: boolean): Promise<FileFilterListItems> => {
    return postApiCall("api/document/module/filefilter/list", FileFilterListItems, JSON.stringify({
        companyId,
        pageSize,
        page,
        sortColumn,
        sortOrder: sortOrderIsAsc ? "asc" : "desc",
        filter: filter || ""
    }));
};

export const getFileFilterEdit = (companyId: string, id: string): Promise<FileFilterEdit> => {
    return getApiCall("api/document/module/filefilter/edit?id=" + id + "&companyId=" + companyId, FileFilterEdit);
};

export const saveFileFilterEdit = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/document/module/filefilter/save", SaveSuccess, JSON.stringify(obj));
};

export const removeFileFilters = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/document/module/filefilter/remove", ApiSuccess, JSON.stringify(obj));
};
// #endregion Module File Filters

// #region Module Keywords
export const getKeywordListItems = (companyId: string, pageSize: number, page: number, filter: string, sortColumn: string, sortOrderIsAsc: boolean): Promise<KeywordListItems> => {
    return postApiCall("api/document/module/keyword/list", KeywordListItems, JSON.stringify({
        companyId,
        pageSize,
        page,
        sortColumn,
        sortOrder: sortOrderIsAsc ? "asc" : "desc",
        filter: filter || ""
    }));
};

export const getKeywordEdit = (companyId: string, id: string): Promise<KeywordEdit> => {
    return getApiCall("api/document/module/keyword/edit?id=" + id + "&companyId=" + companyId, KeywordEdit);
};

export const saveKeywordEdit = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/document/module/keyword/save", SaveSuccess, JSON.stringify(obj));
};

export const removeKeywords = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/document/module/keyword/remove", ApiSuccess, JSON.stringify(obj));
};
// #endregion Module Keywords

// #region Module Other Settings
export const getDocumentSettings = (companyId: string): Promise<DocumentSettings> => {
    return getApiCall("api/document/module/settings/edit?id=" + companyId, DocumentSettings);
};

export const saveDocumentSettings = (obj: any): Promise<DocumentSettingsSave> => {
    return postApiCall("api/document/module/settings/save", DocumentSettingsSave, JSON.stringify(obj));
};
// #endregion Module Other Settings